export enum EmotionTimeframe {
    Days = "Days",
    Weeks = "Weeks",
    Months = "Months",
}
